
import React from "react";
import { FileText, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EmptyTemplateStateProps {
  onCreateTemplate: () => void;
}

const EmptyTemplateState: React.FC<EmptyTemplateStateProps> = ({ onCreateTemplate }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="rounded-full bg-primary/10 p-3 mb-4">
        <FileText className="h-8 w-8 text-primary" />
      </div>
      <h3 className="text-lg font-medium mb-2">No templates yet</h3>
      <p className="text-sm text-muted-foreground mb-4 max-w-sm">
        Create your first email template to use in your automatic replies
      </p>
      <Button onClick={onCreateTemplate} className="gap-2">
        <Plus className="h-4 w-4" />
        Create Template
      </Button>
    </div>
  );
};

export default EmptyTemplateState;
